import { FC, useMemo, memo } from 'react'
import { ComposeId } from 'interfaces/feed'
import { ComposeImages } from 'components/features/socialFeed/ComposeImages/ComposeImages'
import { useShallowSelector } from 'helpers/reactReduxHelpers'
import { createComposeImagesSelector } from 'selectors/feedComposeSelectors'
import { UserImage } from 'interfaces/userImage'
import { ComposeFetchedLink } from 'components/features/socialFeed/ComposeFetchedLink/ComposeFetchedLink'

type ComposeAttachProps = {
  composeId: ComposeId
}

export const ComposeAttach: FC<ComposeAttachProps> = memo((props) => {
  const { composeId } = props
  const composeImagesSelector = useMemo(createComposeImagesSelector, [])
  const images = useShallowSelector<UserImage[]>((store) => composeImagesSelector(store, props))
  const hasImage = useMemo(() => images.length !== 0, [images])

  if (hasImage) {
    return (
      <ComposeImages composeId={ composeId } />
    )
  }

  return (
    <ComposeFetchedLink composeId={ composeId } />
  )
})
